module.exports = __webpack_public_path__ + "img/clickup.d431af71.svg";